import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faBolt } from '@fortawesome/free-solid-svg-icons';
import { Tag } from '@frontend/app/refresh-components';
import { P } from '@frontend/shadcn/components/typography/p';
import { H3 } from '@frontend/shadcn/components/typography/h3';
import { AutomationExecution } from '../constants';
import { formatDateToReadableString, getAutomationExecutionStatus } from '../utils/automationUtils';

type TProps = {
  execution?: AutomationExecution;
};

export const AutomationExecutionItem = (props: TProps) => {
  const { execution } = props;
  const status = getAutomationExecutionStatus(execution?.status);
  return (
    <div data-testid="automation-execution-item" className="border border-border shadow-none rounded-xl p-3 flex gap-2 items-center">
      <div className="flex items-center justify-center w-8 h-8 rounded-xl bg-purple-2">
        <FontAwesomeIcon icon={faBolt} className="text-purple-4" />
      </div>
      <div className="flex-1 flex flex-col gap-1">
        <H3 className="text-sm font-medium text-grey-6 m-0">{formatDateToReadableString(execution?.dateTriggered)}</H3>
        <P className="text-sm font-normal text-grey-6 m-0">{execution?.automation?.name}</P>
        <P className="text-sm font-normal text-grey-5 m-0">{execution?.member?.name}</P>
      </div>
      <div className="ml-auto">
        <Tag bgColor={status?.bg} textColor="text-grey-6" label={status?.text} />
      </div>
    </div>
  );
};
